import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In this section you will connect to the existing Kubernetes Cluster and create an Applciation for RobotShop.`}</p>
    <h2>{`🚀 TASK: Create Kubernetes Connection (Observer)`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=connections-kubernetes" target="_blank">🌏 Documentation for the Task: Creating Kubernetes connections</a>
    <p>{`A Kubernetes connection provides data about workloads in a Kubernetes cluster and namespace that you choose.`}</p>
    <p>{`It loads baseline topology data, such as information about pods, worker nodes, and containers, as well as status from Kubernetes. `}</p>
    <p>{`Create a Kubernetes connection to create a Topology for the internal RoboShop application.`}</p>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p>{`🔎 The parameters can also be found in your configuration file `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` - section  `}<strong parentName="p">{`2.5 Configure Applications - RobotShop Kubernetes Observer`}</strong>{` `}</p>
    </InlineNotification>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`In the `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode>{` “Hamburger” Menu select `}<inlineCode parentName="p">{`Define`}</inlineCode>{`/`}<inlineCode parentName="p">{`Data and tool connections`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Add connection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Under `}<inlineCode parentName="p">{`Kubernetes`}</inlineCode>{`, click on `}<inlineCode parentName="p">{`Add connection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Connect`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`🔎 Get the data from your configuration file `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` - section  `}<inlineCode parentName="p">{`2.5 Configure Applications - RobotShop Kubernetes Observer`}</inlineCode>{` `}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`./tools/11_practicum/get_configuration_info.sh > MY_CONFIGURATION.txt
`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Fill out the first section of fields (Add connection):`}</p>
            <img parentName="li" {...{
              "src": "./../images/39_topo.png",
              "alt": "image"
            }}></img>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`Name:                           RobotShop
Data center:                    robot-shop
`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Fill out the first section of fields (Set advanced options):`}</p>
            <img parentName="li" {...{
              "src": "./../images/40_topo.png",
              "alt": "image"
            }}></img>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`Kubernetes master IP address:   172.21.0.1
Kubernetes API port:            443
Token:                  from MY_CONFIGURATION.txt
Trust all HTTPS certificates:   true
Correlate analytics events:     true
Namespaces to observe:          robot-shop
`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Done`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`The Integration should show `}<inlineCode parentName="p">{`Running`}</inlineCode>{` and eventually `}<inlineCode parentName="p">{`Success`}</inlineCode>{`under Schedule`}</p>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>
    <h2>{`🚀 TASK: Configure RobotShop Application`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=applications-defining-editing" target="_blank">🌏 Documentation for the Task: Defining and editing applications</a>
    <p>{`You define applications by adding Resource Groups, icons and tags, assigning business criticality levels, and setting service disruption costs.`}</p>
    <p>{`Create an application with all RobotShop related Resource Groups.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`In the `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode>{` “Hamburger” Menu select `}<inlineCode parentName="p">{`Operate`}</inlineCode>{`/`}<inlineCode parentName="p">{`Resource management`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select tab `}<inlineCode parentName="p">{`Applications`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Define Application`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select the two Resource Group`}</p>
            <img parentName="li" {...{
              "src": "./../images/41_topo.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Enter Name `}<inlineCode parentName="p">{`RobotShop`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click on the heart to `}<inlineCode parentName="p">{`Mark as favorite`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Enter `}<inlineCode parentName="p">{`1000`}</inlineCode>{` into `}<inlineCode parentName="p">{`Estimated cost per minute for service disruption`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/42_topo.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Define Applications`}</inlineCode></p>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      